export default "__VITE_ASSET__Bv5o4KYd__"